const dictionary = {
    pt_BR: {
      attributes: {
        email: 'E-mail',
        consumer: 'Consumidor',
        product: 'Produto',
        date: 'Data',
        time: 'Hora',
        duration: 'Duração',
        cpfcnpj: 'CPF/CNPJ',
        tariffs: 'Tarifas',
        expirationDateTime: 'Data de expiração',
        tagSelector: 'Etiqueta'
      }
    }
  }
  export default dictionary